import script from "./item.vue?vue&type=script&setup=true&lang=ts"
export * from "./item.vue?vue&type=script&setup=true&lang=ts"

import "./item.vue?vue&type=style&index=0&id=e1d34ca4&lang=less&scoped=true"
import "./item.vue?vue&type=style&index=1&id=e1d34ca4&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1d34ca4"]])

export default __exports__